import './App.css'
import Header from "./components/Header/Header";
import Main from "./components/Main/Main";
import QnA from './components/QnA/QnA';


function App() {

  return (
    <div>
      <Header></Header>
      <Main></Main>
      <QnA></QnA>
    </div>
  );
}

export default App;
